'use strict';
/**
 * @author Maxim Seredkin
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/support-table-row.html'),
        transclude: true,
        scope: {
            support: '=mySupport',
            mySize: '=?mySize',
            myFilters: '=?myFilters',
            myRequired: '=?myRequired',
            myName: '=?myName',
            edit: '=edit',
            serial: '=mySerial',
            openEditSupport: '=openEditSupport'
        },
        controller: ['$scope', 'OrgService', 'OperatorService',
                     function($scope, OrgService, OperatorService) {
                         $scope.select = select;
                         $scope.clear = clear;
                         $scope.parseFieldWithOperator = parseFieldWithOperator;
                         $scope.parseArrayNames = parseArrayNames;
                         $scope.parseArrayCodes = parseArrayCodes;

                         $scope.thead = [
                            'Порядковый номер',
                            'Тип',
                            'ОКВЭД',
                            'Объем инвестиций',
                            'Рабочие места',
                            'Капитальные вложения',
                            'Собственные вложения',
                            'Год',
                            'Территория',
                         ];

                         // region Function

                         function select() {
                             OrgService.select($scope.support, $scope.myFilters).result.then((data) => $scope.support = data);
                         }

                         function clear() {
                             $scope.support = null;
                         }
                         function parseArrayNames(arr) {
                             const result = arr.length ? arr.map(n => n.name).join(', ') : 'Нет данных';
                             return result.length > 20 ? result.slice(0, 20) + '...' : result;
                         }
                         function parseArrayCodes(arr) {
                            const result = arr.length ? arr.map(n => n.code).join(', ') : 'Нет данных';
                            return result.length > 20 ? result.slice(0, 20) + '...' : result;
                        }

                         function parseFieldWithOperator(value1, value2, operator, unit) {
                            if (value1 === null && value2 === null) return 'Нет данных';
                            if (value1 !== null) {
                                if (value2 !== null) {
                                    return `${value1} - ${value2}` + (unit ? ` ${unit}` : '');
                                }
                                return `${OperatorService.getDisplayName(operator)} ${value1}` + (unit ? ` ${unit}` : '');
                            }
                            return `${OperatorService.getDisplayName(operator)} ${value2}` + (unit ? ` ${unit}` : '');
                         }

                         // endregion
                     }],
    };
}
